import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "D:/zlwl/portal/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { cloneDeep, isEqual } from 'lodash';
import { updateConfig } from "@/api/configurationlist";
import { BaudRateList, DataBitList, StopBitList, CheckDigitList, FlowControlList } from '@/utils/com.js';
export default {
  props: ['deviceDid', 'deviceSn'],
  data: function data() {
    return {
      dialogVisible: false,
      index: 0,
      comForm: {
        section: '',
        baudrate: '',
        data_bits: '',
        stop_bits: '',
        parity: '',
        flow_ctrl: '',
        enable_frame: '',
        timeout: '',
        frame_len: ''
      },
      originalCom: {},
      BaudRateList: BaudRateList,
      //波特率选项
      DataBitList: DataBitList,
      //数据位选项
      StopBitList: StopBitList,
      //停止位选项
      CheckDigitList: CheckDigitList,
      //校验位选项
      FlowControlList: FlowControlList //流控选项

    };
  },
  methods: {
    show: function show(item, index) {
      this.comForm.section = item.section;
      this.comForm.baudrate = item.baudrate;
      this.comForm.data_bits = item.data_bits;
      this.comForm.stop_bits = item.stop_bits;
      this.comForm.parity = item.parity;
      this.comForm.flow_ctrl = item.flow_ctrl;
      this.comForm.enable_frame = item.enable_frame == '1' ? true : false;
      this.comForm.timeout = item.timeout;
      this.comForm.frame_len = item.frame_len;
      this.index = index;
      this.dialogVisible = true;
      this.originalCom = cloneDeep(this.comForm);
    },
    updateCom: function updateCom() {
      var _this = this;

      if (!isEqual(this.originalCom, this.comForm)) {
        var copyData = cloneDeep(this.comForm);
        copyData.enable_frame = copyData.enable_frame == true ? '1' : '';
        updateConfig(this.deviceSn, this.deviceDid, [{
          section: copyData.section,
          config: "smartlink",
          action: 0,
          index: [this.index],
          // server: "smartlink",
          options: _objectSpread({}, copyData)
        }]).then(function (res) {
          if (res.data.data.mess === 0) {
            _this.$message.success(_this.$t('lang.ConfigSetting.successSetting'));

            _this.$emit('updateData');

            _this.dialogVisible = false;
          } else {
            _this.$message.error(_this.$t('lang.ConfigSetting.failSetting'));
          }
        });
      } else {
        this.dialogVisible = false;
      }
    }
  }
};